import React from 'react';
export function Footer() {
  return <footer className="bg-bgHero py-16 px-4 sm:px-6 lg:px-8 text-center border-t border-[rgba(232,197,245,0.1)]" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <div className="text-accentText font-sans font-semibold tracking-[0.08em] text-sm uppercase mb-6 flex items-center justify-center gap-2" data-id="element-89">
          <span data-id="element-90">🌙</span> SUEÑO EN PAZ™
        </div>

        <p className="text-bodyOnDark mb-2" data-id="element-91">
          El sistema de sueño natural N°1 para mujeres argentinas.
        </p>
        <p className="text-bodyOnDark/70 text-sm mb-12" data-id="element-92">
          Porque dormir bien no debería ser un lujo.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-sm text-bodyOnDark mb-16" data-id="element-93">
          <a href="mailto:soporte@suenoenpazsistema.com" className="hover:text-headlineLight transition-colors flex items-center gap-2" data-id="element-94">
            <span data-id="element-95">📧</span> soporte@suenoenpazsistema.com
          </a>
          <span className="hidden md:inline text-bodyOnDark/30" data-id="element-96">|</span>
          <a href="#" className="hover:text-headlineLight transition-colors flex items-center gap-2" data-id="element-97">
            <span data-id="element-98">📲</span> @suenoenpazsistema
          </a>
        </div>

        <div className="text-xs text-bodyOnDark/50 space-y-2 mb-12" data-id="element-99">
          <p data-id="element-100">© Sueño en Paz™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-101">Prohibida la reproducción sin autorización expresa.</p>
        </div>

        <p className="font-serif italic text-accentText text-lg" data-id="element-102">
          🌙 "La próxima noche puede ser diferente."
        </p>
      </div>
    </footer>;
}